import React from 'react';
import { asyncConnect } from 'react-async-client';
import { Button, Spin } from 'antd';
import Translate from 'react-translate-component';
import { isEmpty } from 'ramda';

import { getSelected } from 'helpers/listHelpers';
import { getUser, putEnrollCourse } from 'actions/asyncActions';
import CustomIcon from 'components/common/CustomIcon';

const stateToProps = (state) => ({ user: getUser.selectData(state) });

export default asyncConnect({
    putEnrollCourse: putEnrollCourse.withOptions({ autoReset: true })
}, stateToProps)(
    ({ selected, user, putEnrollCourse: { meta, dispatch }, courseList, selectedItem }) => (
        <Button disabled={isEmpty(selected)} onClick={() => dispatch({
            peopleId: user.id,
            selected: selectedItem ? [selectedItem] : getSelected(selected, courseList)
        })}>
            { meta.pending ? <Spin spinning={true} size="small" /> : <CustomIcon type="send" /> }
            <Translate content="education.courses.enroll" />
        </Button>
    )
);
